<div class="email-input-container container-fluid"  [ngClass]="{
        'form-required-border': (!validateEmail(email)  && emailField.dirty && emailField.untouched) || isEmailInvalid
        }">
  <div class="row ps-1 pe-1 align-items-center">
    <div class="col-12 p-0">
      <div class="d-flex flex-wrap align-items-center">
        <!-- Flex container for chips and input -->
        <div class="d-flex flex-wrap" *ngFor="let email of emails; let i = index">
          <div class="chip d-inline-block mb-1 me-2">
            <span class="chip-email">{{ email }}</span>
            <span class="closebtn ms-2" (click)="removeEmail(i)">×</span>
          </div>
        </div>
       
        <input [(ngModel)]="email"
               #emailField="ngModel"
               (keydown.enter)="addEmail()"
               (keydown.space)="addEmail()"
               (blur)="addEmail()"
               (keyup)="onKeyUp($event)"
               placeholder=""
               type="text"
               class="form-control border-0"
               [style.width]="emails.length === 0 ? '100%' : 'auto'"
               />
      </div>
    </div>
  </div>
</div>
